export default {
    more: '更多',
    learn_more: '了解更多',
    view_more: '查看更多',
    search: '查询',
    view: '查看',
    tip: '提示',
    cancel: '取消',
    ok: '确认',
    submit: '提交',
    remark: '备注',
    upload: '上传图片',
    back: '返回',
    search_placeholder: '搜索 ...',
    phone: '电话',
    address: '地址',
    use: '使用',
    confirm: '确认',
    modify: '修改',
    success: '成功！',
    delete: '删除',
    weight: '重量(kg)',
    lwh: '长*宽*高(cm)',
    pay: '支付',
    copy: '复制',
    copy_success: '复制成功！',
    copy_fail: '复制失败！',
    edit: '编辑',
    mobile: '手机号',

    header_1: '首页',
    header_2: '运费预估',
    header_3: '物流查询',
    header_4: '关于我们',
    header_5: '新闻动态',
    header_6: '联系我们',
    header_7: '登录',
    header_8: '注册',
    header_9: '免费注册',
    header_10: '首页',

    banner_1: '发物流用极运',
    banner_2: '简单 & 经济',
    banner_3: '无论您的货物有多重，您都可以信赖我们可靠且负担得起的货运服务。PolarPost在过去的8年里专门从事从中国到澳大利亚的货运进口，我们很自豪能为客户的业务提供货运代理的信心。我们了解客户的业务，可以确保高效的运输，无论是集装箱装载量（LCL）还是整箱装载量（FCL），以及从中国到澳大利亚的空运。',
    banner_4: '联系我们',

    banner_5: '已获许可与认证',
    banner_6: '墨尔本的s77G许可证',
    banner_7: 'IATA成员',
    banner_8: 'AA 1.3级场地',
    banner_9: 'PolarPost的运营完全合规，并得到国际认可。作为墨尔本的s77G许可证持有人，我们有权高效处理保税货物和海关流程。我们的IATA认证确保了航空货运的全球安全和质量标准，而我们的AA Class 1.3站点则证实了我们在严格的安全法规下管理各种货物的能力。这些认证证明了我们的专业可靠性，让客户相信每一批货物都得到了安全透明的管理。使用PolarPost，您的货运代理将得到经过验证的认证和值得信赖的专业知识的支持。',
    banner_10: '中国枢纽与灵活航运',
    banner_11: '广州仓库',
    banner_12: '合并与检查',
    banner_13: '整箱、拼箱、空运、电子商务',
    banner_14: '我们自营的广州仓库是我们中澳物流服务的基础。我们提供原产地检验、供应商协调、合并和出口清关，确保成本效益和可靠的运输。无论您是需要大批量整箱、小批量拼箱、紧急空运还是电子商务包裹服务，PolarPost都能提供灵活的选择，以适应您的商业模式。通过将强大的中国枢纽与多种运输模式相结合，我们确保了顺利高效的货运代理，帮助客户降低成本，增加频率，并自信地扩大运营规模。',
    banner_15: '数字自助服务系统',
    banner_16: '网上申报',
    banner_17: '实时跟踪',
    banner_18: '综合支付',
    banner_19: 'PolarPost提供了一个现代化的数字物流平台，以简化货运管理。客户可以在几分钟内在线提交海关申报，减少文书工作和延误。我们的系统提供实时发货跟踪，确保供应链各个阶段的完全可见性。通过集成的支付和订单管理工具，客户可以在一个地方完成物流工作流程。该自助服务系统专为进口商、电子商务企业和中小企业而设计，可提供速度、透明度和便利性。通过将数字技术与授权专业知识相结合，PolarPost使国际货运更加高效和客户友好。',
    banner_20: '端对端服务',
    banner_21: '中国供应商提货',
    banner_22: '澳大利亚清关',
    banner_23: '墨尔本交货',
    banner_24: 'PolarPost提供完整的端到端物流解决方案。我们直接从中国的供应商那里收集货物，在广州中心安排检验和合并，并管理所有出口文件。在运输过程中，我们的团队确保合规性和效率，而在澳大利亚，我们的清关专家以最小的延迟处理进口流程。最后，我们在墨尔本的最后一英里配送网络保证及时配送到您的仓库、零售店或电子商务履行中心。通过在一个屋檐下管理每一步，我们简化了国际运输，节省了成本，并为客户提供了无缝的物流体验。',

    service_1: 'FCL 服务',
    service_2: '大批量发货？使用PolarPost整箱装载服务。当您的货物量足够装满20和40的集装箱时，PolarPost可以以最具竞争力的价格为您提供整箱服务。无论您是想在工厂密封集装箱，还是想整合来自不同供应商的货物，PolarPost都可以为您提供帮助。',
    service_3: 'LCL 服务',
    service_4: '如果您的货物小于集装箱装载量，同时您还有一些空闲时间。LCL可能是您正在寻找的服务。如果你想更频繁地发货并节省库存仓储空间，拼箱可能是你能选择的最佳选择。PolarPost提供从中国到澳大利亚的全套拼箱服务。点击此处学习 ',
    service_5: '空运',
    service_6: '急需您的货物吗？使用PolarPost航空货运服务。PolarPost正努力在疫情期间提供最好的服务。如果你有一批小货，而且很快就需要，尤其是价值低于1000美元。PolarPost电子商务空运服务可以为您提供最经济、最快捷的方式。',
    service_7: '清关',
    service_8: '持证专家负责处理澳大利亚的清关和经纪业务，以及从其他国家进口货物的清关事宜。',
    service_9: '',

    advantage_1: '极运特殊服务',
    advantage_2: 'PolarPost可以将来自不同供应商的货物合并为一个，降低您的运输成本！您不必为来自多个供应商的不同货物通用多个HBL。您只需将它们发送到中国的PolarPost HUB，PolarPost就可以为您整合它们。因此，从中国出口和进口到澳大利亚时，您只需支付一次管理费用。我们的设施位于中国广州，地理位置优越；澳大利亚墨尔本确保我们的服务始终处于控制之下，无论是在出发地还是目的地。数百名PolarPost的客户每年通过使用PolarPost整合服务节省了数千美元。',
    advantage_3: '运费代理',
    advantage_4: 'Polar Express仅为其客户提供一流的货运代理服务。我们是一家经国际航空运输协会（IATA）认证的成熟航空货运代理公司。',
    advantage_5: '',
    advantage_6: '',
    advantage_7: '',
    advantage_8: '',
    advantage_9: '',
    advantage_10: '',
    advantage_11: '',
    advantage_12: '',
    advantage_13: '报关',
    advantage_14: 'PolarPost只与澳大利亚最有信誉的海关经纪机构合作。',
    advantage_15: '',

    support_1: '支持',
    support_2: "空运和海运之间的差异似乎很明显，但对于进口商和出口商来说，还有更多的东西。我们的海运空运指南将帮助您了解每种方式的优缺点，并引导您朝着最适合下一批货物的方向前进。",
    support_3: '信息中心',
    support_4: '箱子尺寸您应该使用的最佳箱子',
    support_5: '货运危险品表',

    footer_1: '关于极运',
    footer_2: 'PolarPost（Polar Express Pty Ltd）于2014年在墨尔本成立，9年来一直提供专业的货运代理解决方案。',
    footer_3: '全球11个仓库',
    footer_4: '14000+平方米的仓库空间',
    footer_5: '为数百家澳大利亚进口商提供可靠的中澳物流服务',
    footer_6: '关于我们',
    footer_7: '联系我们',
    footer_8: '电话',
    footer_9: '邮箱',
    footer_10: '微信',

    calc_1: '预估运费',
    calc_2: '请输入包裹信息以完成运费估算。',
    calc_3: '包裹信息',
    calc_4: '邮寄线路',
    calc_5: '取货方式',
    calc_6: '门店自取',
    calc_7: '送货上门',
    calc_8: '地址',
    calc_9: '电话',
    calc_10: '备注',
    calc_11: '邮编',
    calc_12: '国际段运费',
    calc_13: 'Domestic',
    calc_14: '总运费',
    calc_15: '注意',
    calc_16: '以上运费基于普通货物（非特需）、不拆包，以及输入的重量和体积重（长*宽*高cm/{amount}）二者取大值计算得出，不含增值服务费用，仅作参考，实际费用以最终提交转运单时计算的运费为准。',
    calc_17: '请输入包裹信息来完成运费预估',
    calc_18: '包裹重量、取货方式为必填项。长、宽、高等信息为非必填项。',
    calc_19: '{amount} 起',
    calc_20: '提交',
    calc_21: '重量',
    calc_22: '重量',
    calc_23: '件数',
    calc_24: '件数',
    calc_25: '长 / 宽 / 高',
    calc_26: '长',
    calc_27: '宽',
    calc_28: '高',

    track_1: '物流查询',
    track_2: '查询',
    track_3: '请输入物流运单号',
    track_4: '清空历史搜索',

    article_1: '新闻动态',
    article_2: '你有问题，我们有答案。',
    article_3: '暂无数据',
    article_4: '请输入文章标题',
    article_5: '关于我们',
    article_6: '新闻动态',

    contact_1: '联系我们',
    contact_2: '你有问题，我们有答案。',
    contact_3: '姓名',
    contact_4: '邮箱',
    contact_5: '电话',
    contact_6: '公司',
    contact_7: '留言',
    contact_8: '请告知我们您的货运需求，例如，从中国的哪个城市运往墨尔本，货物类型等。',
    contact_9: '提交',
    contact_10: '关于我们',
    contact_11: 'Polar Post 是一家值得信赖的物流供应商，专门提供',
    contact_12: '中澳运输解决方案。',
    contact_13: '持证且认证',
    contact_14: '墨尔本AA级1.3类场地，国际航空运输协会（IATA）成员',
    contact_15: '中国枢纽优势',
    contact_16: '广州自营仓库，提供检验、集拼和清关服务',
    contact_17: '灵活的运输方式',
    contact_18: '空运、海运（整箱/拼箱）以及电商包裹',
    contact_19: '海关专业服务',
    contact_20: '通过简化申报系统提供专业清关服务',
    contact_21: '凭借超过10年的经验，Polar Post帮助澳大利亚进口商降低成本、简化供应链，并确保从中国到澳大利亚的货物顺利交付。',
    contact_22: '关于极运',

    login_1: '登录',
    login_2: '输入邮箱登录',
    login_3: '邮箱',
    login_4: '请输入邮箱！',
    login_5: '密码',
    login_6: '请输入密码！',
    login_7: '登录',
    login_8: "没有账户？",
    login_9: '注册',
    login_10: '忘记密码？',
    login_11: '重置密码',

    register_1: '注册',
    register_2: '请使用邮箱免费注册',
    register_3: '邮箱验证',
    register_4: '账户信息',
    register_5: '注册成功',
    register_6: '请输入邮箱！',
    register_7: '请输入邮箱',
    register_8: '请输入验证码！',
    register_9: '请输入验证码',
    register_10: '请输入邮箱验证码！',
    register_11: '请输入邮箱验证码',
    register_12: '请输入你的昵称！',
    register_13: '请输入你的昵称',
    register_14: '请输入密码！',
    register_15: '请输入密码',
    register_16: '已同意并阅读',
    register_17: '客户条款与协议',
    register_18: '发送邮箱验证码',
    register_19: '注册',
    register_20: '登录',
    register_21: '已有账户？ ',
    register_22: '请阅读并同意客户条款与协议',

    password_1: '重置密码',
    password_2: '请使用邮箱重置密码',
    password_3: '邮箱验证',
    password_4: '输入密码',
    password_5: '成功',
    password_6: '请输入邮箱！',
    password_7: '邮箱',
    password_8: '请输入验证码！',
    password_9: '验证码',
    password_10: '请输入邮箱验证码！',
    password_11: '邮箱验证码',
    password_12: '请输入新密码！',
    password_13: '新密码',
    password_14: '请再次输入新密码！',
    password_15: '确认密码',
    password_16: '验证邮箱并发送验证码',
    password_17: '提交',
    password_18: '已有账户? ',
    password_19: '登录',
    password_20: '邮箱不能为空！',

    side_1: '会员中心',
    side_2: '添加包裹',
    side_3: '提交转运',
    side_4: '我的转运',
    side_5: '退运包裹',
    side_6: '收件地址',
    side_7: '账户',
    side_8: '会员信息',
    side_9: '会员充值',
    side_10: '余额记录',


    info_1: '在仓包裹',
    info_2: '待出库',
    info_3: '待支付',
    info_4: '余额',
    info_5: '所有包裹',
    info_6: '快递单号',
    info_7: '内件信息',
    info_8: '重量/体积',
    info_9: '入库时间',
    info_10: '操作',
    info_11: '状态',
    info_12: '创建时间',
    info_14: '在仓包裹',
    info_15: '包裹已入仓，请在发货前申报',
    info_16: '已出库',
    info_17: '包裹已出库，等待发货',
    info_18: '转运仓地址',
    info_19: '一键复制',
    info_20: '如何使用？',
    info_21: '提示',
    info_22: '您可以与发件人共享提供的地址，有中英文两种版本。请注意，大多数中国供应商更喜欢使用中文版本的地址。请在地址中注明唛头，以帮助我们将货物分配到您的账户。如果可能的话，如果您能要求发件人在货物上至少包含一个唛头，我们将不胜感激。如果您的货物上找不到唛头，您需要在我们的系统中使用您的内陆跟踪号注册货物。这将使我们能够正确地将货物分配到您的账户。',
    info_23: '你好：',
    info_24: '点击这里预估国际运费',
    info_25: '点击这里',
    info_25: '申报',
    info_27: '待发货',
    info_28: '在途包裹',
    info_29: '派送中',
    info_30: '待取货',
    // 添加包裹
    pd_1: '基本信息',
    pd_2: '快递单号',
    pd_3: '物流公司',
    pd_4: '图片',
    pd_5: '备注',
    pd_6: '内件类别',
    pd_7: '请选择类别',
    pd_8: '内件信息',
    pd_9: '购买链接',
    pd_10: '补充备注',
    pd_11: '申报价格',
    pd_12: '数量',
    pd_13: '当上传图片时：',
    pd_14: '内件类别：',
    pd_15: "如果您无法找到适合您产品的类别，请选择TBC并上传产品图片，以便团队协助正确分类。",
    pd_16: '对于超过 A$900 的货物：',
    pd_17: "如果总装运价值超过900澳元，您必须上传发票，因为澳大利亚当局清关时需要发票。",
    pd_18: '添加一个内件',
    pd_19: '提交',
    pd_20: '预报提醒',
    pd_21: '您当前的包裹包含不同类型的商品。确认后，系统将据此进行操作：',
    pd_22: "当前包裹内含有“待定物品”，请补充购买链接和补充备注。如缺少信息，则包裹入仓后需要由管理员核实内件类别后才可提交转运订单。",
    pd_23: "申报的物品必须严格符合澳大利亚的个人进口要求。 根据澳大利亚法律，某些物品不能通过个人包裹进口。 不遵守可能会导致法律后果。点击查看更多: ",
    pd_24: '！当前包裹已入库如信息无误请点击认领包裹按钮否则请点击有疑问后联系网站客服处理',
    pd_25: '认领包裹',
    pd_26: '有疑问？',
    pd_27: '操作',
    pd_28: '内件',
    pd_29: '此包裹已预报，请直接申报。',
    pd_30: '修改成功！',
    pd_31: '删除将会导致信息丢失，确认删除？',
    pd_32: '查看图片',
    pd_33: '当前已有包裹在仓',
    pd_34: '物流单号',
    pd_35: '物流公司',
    pd_36: '长宽高(cm)',
    pd_37: '重量',
    pd_38: "管理员备注",
    pd_39: '入库时间',
    pd_40: '拍照图片',
    // 提交转运
    cs_1: '配置标签',
    cs_2: '快递单号',
    cs_3: '内件详情',
    cs_4: '申报',
    cs_5: '待转运',
    cs_6: '当前运输申报总价',
    cs_7: '添加标签',
    cs_8: '移除标签',
    cs_9: '包裹商品详情',
    cs_10: '状态',
    cs_11: '未入仓',
    cs_12: '验货中',
    cs_13: '完成入库',
    cs_14: '拒收',
    cs_15: '待发货',
    cs_16: '已出仓',
    cs_17: '作废',
    cs_18: '等待退运',
    cs_19: '已退运',
    cs_20: '重量(kg) / 尺寸(cm) / 包裹价值(A$)',
    cs_21: '内件信息',
    cs_22: '入库时间',
    cs_23: '标签',
    cs_24: '请选择包裹！',
    cs_25: '删除操作将导致信息丢失，您确定要删除吗？',
    cs_26: '修改成功！',
    cs_27: '修改失败！',
    cs_28: '请先选择包裹！',
    cs_29: '删除将会导致信息丢失，确认删除？',
    cs_30: '请确认并提交',
    cs_31: '成功！',
    cs_32: '失败！',
    cs_33: '退运',
    cs_34: '删除',
    cs_35: '包裹',

    // 退运包裹
    pr_1: '退运快递明细',
    pr_2: '快递单号',
    pr_3: '计费重量',
    pr_4: '长*宽*高(cm)',
    pr_5: '入库时间',
    pr_6: '包裹明细',
    pr_7: '收件人',
    pr_8: '清空收件人',
    pr_9: '姓名',
    pr_10: '电话',
    pr_11: '省/州',
    pr_12: '市',
    pr_13: '区',
    pr_14: '邮编',
    pr_15: '详细地址',
    pr_16: '请选择并认真阅读条款',
    pr_17: '同意条款',
    pr_18: '费用明细',
    pr_19: '超时费用',
    pr_20: '积分抵扣',
    pr_21: '应付金额',
    pr_22: '免责声明',
    pr_23: '提交',
    pr_24: '当前积分最多可用',
    pr_25: '取货方式',
    pr_26: '取货码',
    pr_27: '请输入备注...',

    // 退运列表
    prl_1: '流水号',
    prl_2: '收件人',
    prl_3: '流水号',
    prl_4: '状态',
    prl_5: '未支付',
    prl_6: '处理中',
    prl_7: '拣货中',
    prl_8: '已出库',
    prl_9: '作废',
    prl_10: '类型',
    prl_11: '收件人',
    prl_12: '金额',
    prl_13: '下单时间',
    prl_14: '全部',
    prl_15: '委托寄回',
    prl_16: '上门取件',
    prl_17: '类型',

    // 退运包裹详情
    prv_1: '退运订单详情',
    prv_2: '状态',
    prv_3: '类型',
    prv_4: '操作费用',
    prv_5: '收件人地址',
    prv_6: '包裹编号',
    prv_7: '快递单号',
    prv_8: '状态',
    prv_9: '实际重量(kg)',
    prv_10: '图片',
    prv_11: '出库快递单号',
    prv_12: '创建时间',
    prv_13: '包裹编号',
    prv_14: '收件人',
    prv_15: '取货码',

    // 提交转运
    st_1: '快递明细',
    st_2: '快递单号',
    st_3: '计费重量',
    st_4: '计费立方',
    st_5: '长*宽*高(cm)',
    st_6: '入库时间',
    st_7: '包裹明细',
    st_8: '增值服务',
    st_9: '收件人',
    st_10: '导入',
    st_11: '清空收件人',
    st_12: '邮寄线路',
    st_13: '门店自取',
    st_14: '送货上门',
    st_15: '请选择并认真阅读条款',
    st_16: '同意条款',
    st_17: '选择',
    st_18: '费用明细',
    st_19: '货品用途',
    st_20: '个人自用',
    st_21: '商业用途',
    st_22: '公司名',
    st_23: 'ABN',
    st_24: '账单邮箱',
    st_25: '修改',
    st_26: '保险费用',
    st_27: '投保金额(投保比例: {insure}%)',
    st_28: '投保金额(投保比例:10%)',
    st_29: '优惠码',
    st_30: '当前积分：',
    st_31: '积分',
    st_32: '积分',
    st_33: '费用明细',
    st_34: '截止',
    st_35: '计费重量',
    st_36: '计费立方',
    st_37: '国际段运费',
    st_38: '增值服务费用',
    st_39: '末端派送',
    st_40: '门店服务费',
    st_41: '报关费',
    st_42: '大件费',
    st_43: '操作费',
    st_44: '限时折扣',
    st_44_1: '优惠金额',
    st_45: '积分抵扣',
    st_46: '保险金额',
    st_47: '应付金额',
    st_48: '免责声明',
    st_49: '选择地址',
    st_50: '收费说明',
    st_51: '提交',
    st_52: '快递明细',
    st_53: '商品名称',
    st_54: '图片',
    st_55: '内件类别',
    st_56: '商品数量',
    st_57: '单价',
    st_58: '修改增值服务',
    st_59: '选择增值服务',
    st_60: '货品用途',
    st_61: '需额外缴纳GST！',
    st_62: '货品用途',
    st_63: '公司名',
    st_64: 'ABN',
    st_65: '账单邮箱',
    st_66: '增值服务明细',
    st_67: '尊敬的用户，您好！',
    st_68: '需收取增值服务费',
    st_69: '需收取入库超时费',
    st_70: '增值费用总计',
    st_71: '已超期',
    st_72: '天',
    st_73: '请先勾选',
    st_74: '当前积分最多可用：',
    st_75: '使用积分抵扣金额不允许超过订单金额',
    st_76: '不使用优惠券',
    st_77: '请输入公司名',
    st_78: '请输入ABN',
    st_79: '请输入账单邮箱',
    st_80: '取货方式',
    st_81: '请输入备注',
    st_82: '增值服务',

    // 包裹详情
    pv_1: '快递明细',
    pv_2: '包裹编号',
    pv_3: '在仓时间',
    pv_4: '超时费',
    pv_5: '状态',
    pv_6: '图片',
    pv_7: '操作时间',
    pv_8: '快递单号',
    pv_9: '包裹编号',
    pv_10: '重量',
    pv_11: '长宽高',
    pv_12: '增值服务',
    pv_13: '操作费',
    pv_14: '操作费说明',
    pv_15: '快递包裹单号',
    pv_16: '备注',
    pv_17: '商品名称',
    pv_18: '图片',
    pv_19: '内件类别',
    pv_20: '商品数量',
    pv_21: '单价',

    // 消息列表
    msg_1: '全部已读',
    msg_2: '标题',
    msg_3: '发送人',
    msg_4: '标题',
    msg_5: '状态',
    msg_6: '发送人',
    msg_7: '内容',
    msg_8: '创建时间',
    msg_9: '操作',
    msg_10: '确认删除？',
    msg_11: '确认全部已读?',
    msg_12: '管理员',

    // 订单列表
    o_1: '状态',
    o_2: '编号',
    o_3: '撤回',
    o_4: '支付',
    o_5: '转运包裹单号/状态',
    o_6: '重量',
    o_7: '长/宽/高',
    o_8: '订单目前正在处理中。',
    o_9: '更多',
    o_10: '订单编号',
    o_11: '线路',
    o_12: '物流方式',
    o_13: '重量 / 价格',
    o_14: '创建时间',
    o_15: '全部',
    o_16: '等待支付',
    o_17: '检验包裹',
    o_18: '确认包裹',
    o_19: '已转运',
    o_20: '自提',
    o_21: '邮寄',
    o_22: '转运包裹单号/状态',
    o_23: '重量',
    o_24: '长/宽/高',
    o_25: '是否确认操作？',

    // 订单详情
    ov_1: '订单信息',
    ov_2: '快递明细',
    ov_3: '订单信息',
    ov_4: '个人用途',
    ov_5: '商业用途',
    ov_6: '入库重量',
    ov_7: '计费立方',
    ov_8: '国际段运费：',
    ov_9: '增值服务费用：',
    ov_10: '末端派送：',
    ov_11: '门店服务费：',
    ov_12: '报关费：',
    ov_13: 'GST费用：',
    ov_14: '大件费：',
    ov_15: '附加费：',
    ov_16: '操作费：',
    ov_17: '优惠金额减扣：',
    ov_18: '积分减扣：',
    ov_19: '活动满减减扣：',
    ov_20: '商业用途GST费用：',
    ov_21: '保险金额：',
    ov_22: '应付总额：',
    ov_23: '姓名',
    ov_24: '地址',
    ov_25: '编号',
    ov_26: '订单状态',
    ov_27: '取货方式',
    ov_28: '线路',
    ov_29: '收件人',
    ov_30: '收件人电话',
    ov_31: '收件人地址',
    ov_32: '是否拆包',
    ov_33: '创建时间',
    ov_34: '增值服务',
    ov_35: '货品用途',
    ov_36: '快递明细',
    ov_37: '打包包裹',
    ov_38: '金额',
    ov_39: '转运包裹单号',
    ov_40: '快递单号',
    ov_41: '状态',
    ov_42: '入库重量(kg)',
    ov_43: '长*宽*高(cm)',
    ov_44: '商品明细',
    ov_45: '创建时间',
    ov_46: '出库时间',
    ov_47: '图片',
    ov_48: '快递单号',
    ov_49: '增值服务',
    ov_50: '内件详情',
    ov_51: '创建时间',
    ov_52: '包裹个数',
    ov_53: '门店信息',

    // 支付页面
    pay_1: '您的订单已提交成功，请确认信息后进行付款！',
    pay_2: '您已提交退运，请确认信息后进行付款！',
    pay_3: '您已提交核验，请确认信息后进行付款。',
    pay_4: '您已提交核重补款，请确认信息后付款。',
    pay_5: '成功付款后，我们将尽快发货',
    pay_6: '成功付款后，我们将尽快处理',
    pay_7: '订单号',
    pay_8: '支付单',
    pay_9: '金额信息：',
    pay_10: '国际段运费',
    pay_11: '增值服务费用',
    pay_12: '末端派送',
    pay_13: '门店服务费',
    pay_14: '报关费',
    pay_15: '大件费',
    pay_16: '附加费',
    pay_17: '操作费',
    pay_18: '优惠金额减扣',
    pay_19: '积分减扣',
    pay_20: '活动满减减扣',
    pay_21: '商业用途GST费用',
    pay_22: '保险金额',
    pay_23: '包裹个数',
    pay_24: '预估缴费重量',
    pay_25: '预估缴费体积',
    pay_26: '金额信息',
    pay_27: '选择支付方式',
    pay_28: '需额外支付手续费',
    pay_29: '安全的澳币支付方式',
    pay_30: '选择使用余额',
    pay_31: '当前余额',
    pay_32: '订单信息',
    pay_33: '订单金额',
    pay_34: '优惠券',
    pay_35: '余额抵扣',
    pay_36: '积分抵扣',
    pay_37: '应付金额',
    pay_38: '手续费',
    pay_39: '实付金额',
    pay_40: '确认进行支付',
    pay_41: '上传凭证',
    pay_42: '线下支付信息',
    pay_43: '支付方式',
    pay_44: '账户名称',
    pay_45: '银行账号',
    pay_46: '金额',
    pay_47: '单号',
    pay_48: '上传凭证',
    pay_49: '扫码支付',
    pay_50: '请上传凭证！',
    pay_51: '支付成功!',
    pay_52: '页面将于{second}秒后自动跳转，您可以点击直接跳转',
    pay_53: '查看详情',
    pay_54: '继续下单',
    pay_55: '继续充值',

    // 地址列表
    a_1: '新增地址',
    a_2: '姓名',
    a_3: '电话',
    a_4: '邮编',
    a_5: 'Name',
    a_6: 'Phone',
    a_7: 'Address1',
    a_8: 'Address2',
    a_9: 'Area/State/Postcode',
    a_10: '收件人',
    a_11: '收件人号码',
    a_12: '收件人地址',
    a_13: '邮编',
    a_14: '创建时间',
    a_15: '操作',
    a_16: '确认删除吗？',
    a_17: "'Name' is required!",
    a_18: "'Phone' is required!",
    a_19: "'State' is required!",
    a_20: "'Area' is required!",
    a_21: "'Postcode' is required!",
    a_22: "'Address' is required!",

    // 余额记录
    cd_1: '余额行为',
    cd_2: '编号',
    cd_3: '余额行为',
    cd_4: '费用(A$) / 余额(A$)',
    cd_5: '支付单编号',
    cd_6: '备注',
    cd_7: '时间',
    cd_8: '全部',
    cd_9: '入账(后台充值)',
    cd_10: '支出(后台扣除)',
    cd_11: '支出(购物)',
    cd_12: '支出(运费)',
    cd_13: '入账(会员充值)',

    // 物流信息
    pg_1: '物流信息',
    pg_2: '已发货',
    pg_3: '在途中',
    pg_4: '已签收',
    pg_5: '已完成',
    pg_6: '包裹单号',
    pg_7: '订单号',
    pg_8: '取货方式',
    pg_9: '线路',
    pg_10: '状态',
    pg_11: '创建时间',
    pg_12: '电话',
    pg_13: '地址',
    pg_14: '门店信息',

    // 会员信息
    pf_1: '个人资料',
    pf_2: '这些信息将让我们更多地了解您。',
    pf_3: '头像/昵称',
    pf_4: '手机号',
    pf_5: '修改密码',
    pf_6: "基本信息",
    pf_7: '上传您的个人头像并输入昵称可以让我们更全面地了解您',
    pf_8: '会员等级',
    pf_9: '会员编号',
    pf_10: '会员昵称',
    pf_11: "绑定手机号",
    pf_12: '请输入您的手机号并点击获取验证码',
    pf_13: '手机号',
    pf_14: '手机验证码',
    pf_15: '重新发送',
    pf_16: '发送',
    pf_17: "修改密码",
    pf_18: '输入旧密码，然后输入新密码，最后再次输入新密码进行确认',
    pf_19: '旧密码',
    pf_20: '新密码',
    pf_21: '确认密码',
    pf_22: '请上传头像',

    // 充值
    r_1: '充值金额',
    r_2: '货币',
    r_3: '充值金额',
    r_4: '充值会员编码',
    r_5: '支付方式',
    r_6: '需额外支付手续费',
    r_7: '安全的澳币支付方式',
    r_8: '确认进行支付',
    r_9: '上传凭证',
    r_10: '线下支付信息',
    r_11: '支付方式',
    r_12: '账户名称',
    r_13: '银行账号',
    r_14: '单号',
    r_15: '上传凭证',
    r_16: '扫码支付',
    r_17: '请选择充值金额！',
    r_18: '请输入充值金额！',
    r_19: '请选择充值方式！',
    r_20: '请上传凭证',
    r_21: '金额',
}